module.exports = __webpack_public_path__ + "./images/logo.png?f1edc483335f7bf46e0e3c1cbd2228b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 11
// module chunks = 0